<lib-block-title
  id="porting-title"
  [title]="labels.title">
</lib-block-title>

<section
  class="fx-row fx-gap-3 fx-wrap fx-justify-end"
  id="porting-options">
  <section
    class="fx-row fx-gap-3"
    [formGroup]="filters">
    <customer-simple-button
      [disabled]="((isPortingDisabled$ | async) === true) || ((userAuthorized$ | async) === false)"
      [label]="labels.portingButton"
      [action]="portPlants">
    </customer-simple-button>
    <mat-checkbox
      data-testid="mat-checkbox-only-advanced"
      class="body-2"
      formControlName="onlyPortable">
      {{ labels.onlyPortable }}
    </mat-checkbox>
  </section>
  <customer-search
    [placeholder]="labels.searchOnTable"
    [query]="query"
    (queryChange)="query$.next($event)">
  </customer-search>
</section>

<section id="porting-disclaimer">
  <ng-container *ngTemplateOutlet="portingDisclaimerTemplate ? portingDisclaimerTemplate : portingDisclaimerDefault"></ng-container>

  <ng-template #portingDisclaimerDefault>
    <section
      *ngIf="(userAuthorized$ | async) === false"
      class="border-1 fx-row fx-gap-3 p-3 radius-4 radius-2 border-grey-100">
      <mat-icon class="text-grey-400 d-contents">
        info
      </mat-icon>
      <customer-title-content
        class="fx-g-1"
        [title]="labels.authorizedDisclaimerTitle"
        [content]="labels.authorizedDisclaimerContent">
      </customer-title-content>
    </section>
  </ng-template>
</section>

<azzurro-table
  id="porting-table"
  [labels]="labels"
  [columns]="columns"
  [paginationConfig]="{
    pageSize: (pagination$ | async)?.pageSize,
    hasMore: (pagination$ | async)?.hasMore,
    pageSizeOptions: pageSizeOptions,
    length: NO_LEN,
  }"
  [data$]="dataSource$"
  [tableId]="'deviceRegistry'"
  [mode]="'server'"
  [showColumnToggleButton]="true"
  [pagination]="true"
  [noResultTemplate]="noResult"
  [filterEnabled]="false"
  (pageChanged)="onPageChange($event)">
</azzurro-table>

<azzurro-table
  id="porting-list"
  uiFramework="ionic"
  [labels]="labels"
  [columns]="columns"
  [paginationConfig]="{
    pageSize: (pagination$ | async)?.pageSize,
    hasMore: (pagination$ | async)?.hasMore,
    pageSizeOptions: pageSizeOptions,
    length: NO_LEN,
  }"
  [data$]="dataSource$"
  [tableId]="'deviceRegistry'"
  [mode]="'server'"
  [showColumnToggleButton]="true"
  [pagination]="true"
  [noResultTemplate]="noResult"
  [filterEnabled]="false"
  (pageChanged)="onPageChange($event)">
</azzurro-table>

<ng-template #noResult>
  <div class="fx-center tw-font-medium text-grey-400 no-data">
    {{ labels.noResults }}
  </div>
</ng-template>

<ng-template
  #devicesPreview
  let-row>
  <lib-plant-card-overview
    class="fx-r-row fx-justify-end m-3"
    [labels]="{
      connectedAndUpdated: labels.connectedAndUpdated,
      disconnected: labels.disconnected,
      notUpdated: labels.notUpdated,
      updated: labels.updated,
      hasAlerts: labels.hasAlerts,
    }"
    [notStatus]="true"
    [system]="row.system">
  </lib-plant-card-overview>
</ng-template>

<ng-template
  #plantNamePreview
  let-row>
  <ngx-copy-to-clipboard
    class="text-grey-400"
    position="right"
    [textToCopy]="row.system.name">
    <span class="ellipsed">
      {{ row.system.name }}
    </span>
  </ngx-copy-to-clipboard>
</ng-template>

<ng-template
  #actionPreview
  let-row>
  <mat-checkbox
    *ngIf="row.portability === Portability.PORTABLE; else noCheckbox"
    [disabled]="!(userAuthorized$ | async)"
    [checked]="row.selected$ | async"
    (change)="row.toggleSelection()">
  </mat-checkbox>
  <ng-template #noCheckbox>
    <mat-icon class="text-grey-300 s-6 m-2">disabled_by_default</mat-icon>
  </ng-template>
</ng-template>

<ng-template
  #actionHeaderPreview
  let-row>
  <div class="ellipsed fx-row fx-align-center">
    <div class="ellipsed">
      {{ labels.action }}
    </div>
    <div *ngIf="portingSelectedPlants$ | async as portingSelectedPlants">
      {{ portingSelectedPlants?.length ? '(' + portingSelectedPlants.length + ')' : '' }}
    </div>
    <mat-checkbox
      [disabled]="!(userAuthorized$ | async)"
      [checked]="(portingSelectAll$ | async) === 'checked'"
      (change)="toggleAllSelection($event)">
    </mat-checkbox>
  </div>
</ng-template>
